






































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import cPopup from '@/components/default/Popup.vue';
import contactsRepository from '@/services/contactsRepository';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxLabel } from 'devextreme-vue/form';
import Subcontractor from '@/classes/CRM/Subcontractor';
import notificationService from '@/services/notificationService';
import { CreateTeamCommand, Team, TeamsClient, UpdateTeamCommand } from '@/data/web-api-client';

@Component({
  components: {
    cPopup,
    DxSimpleItem,
    DxForm,
    DxLabel,
    DxRequiredRule,
    DxItem,
    DxGroupItem,
  },
})
export default class SubcontractorTeamPopup extends Vue {
  public subcontractor!: any;
  public members: any[] = [];

  public team: Team = new Team();
  teamsClient: TeamsClient = new TeamsClient(undefined, this.$axios);

  show: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  isNew: boolean = false;

  public async Open(subcontractor: Subcontractor, team: any) {
    this.subcontractor = subcontractor;
    this.team = team;
    this.show = true;
    this.initTeam();
    this.getContacts();
  }

  public close() {
    this.isNew = false;
    this.show = false;
  }

  mounted() {}

  async getContacts() {
    this.members = (await contactsRepository.getRelations(this.subcontractor.id!)).data.filter((o: IBasicContact) => o.type === 'Contact').map((x: any) => x.displayName);
  }

  initTeam() {
    if (this.team.id == '') {
      this.isNew = true;
    }

    if (this.subcontractor.teamIds == null) {
      this.subcontractor.teamIds = [];
    }
  }

  async save() {
    const form: any = this.$refs.teamsForm;
    const validationResult = form.instance.validate();
    if (validationResult.isValid) {
      if (this.isNew) {
        this.team.subcontractorId = this.subcontractor.id;
        var result = await this.teamsClient.postCreateTeam(new CreateTeamCommand({ team: this.team }));
        this.subcontractor.teamIds.push(result.toString());
      } else {
        await this.teamsClient.postUpdateTeam(new UpdateTeamCommand({ team: this.team }));
      }
      this.subcontractor.save();
      this.close();
    } else {
      notificationService.invalidForm();
    }

    this.$emit('saved');
  }

  get worktypesOptions() {
    const catalog = this.$store.getters['catalogs/list']('WorkTypes') as ICatalogList;
    return { items: catalog ? catalog.values : [] };
  }

  get memberOptions() {
    return { items: this.members ? this.members : [] };
  }
}
